import { Environment } from '@web/service';

export const logAppVersion = (app: string, environment: Pick<Environment, 'version'>) => {
  const version = environment.version;
  if (version) {
    console.log(`${app} Application: ${version.commit}${version.tag ? ` (${version.tag})` : ''}`);
  }
};
